import { useState } from "react";
import PrimaryButton from "../../buttons/PrimaryButton";
import SecondaryButton from "../../buttons/SecondaryButton";
import Dropzone3 from "../../dropzones/DropZone3";
import ExtractionLoading from "../../loading/ExtractionLoading";
import extractDevisInfosFromFile from "../../api/ai/extractDevisInfosFromFile";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import uploadDropZoneTemporary from "../../api/upload/uploadDropZoneTemporary";
import Modal1 from "../../modals/Modal1";

export default function NewDevisExtractionFromFile({
  onClose,
  prefix,
  setNom,
  setPrenom,
  setCivilite,
  setEmail,
  setTelephone,
  setAdresse,
  setVille,
  setPostal,
  setAdresseProjet,
  setVilleProjet,
  setPostalProjet,
  onFileUploaded,
  handleClickVariant,
}) {
  const [droppedFiles, setDroppedFiles] = useState([]);
  const [selectedFiles, setSelectedDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [extracting, setExtracting] = useState(false);

  const handleExtractInfosFromFile = async (file) => {
    if (!file) {
      handleClickVariant("Veuillez sélectionner un fichier", "error");
      return;
    }
    setExtracting(true);
    try {
      const token = await getOrRefreshFirebaseToken();

      // Run extraction and file upload in parallel
      const [res, uploadRes] = await Promise.all([
        extractDevisInfosFromFile(file, token, prefix),
        uploadDropZoneTemporary(token, file, file.name, prefix),
      ]);

      if (res) {
        if (res.civilite_maitre_ouvrage) setCivilite(res.civilite_maitre_ouvrage);
        if (res.nom_maitre_ouvrage) setNom(res.nom_maitre_ouvrage);
        if (res.first_name_maitre_ouvrage) setPrenom(res.first_name_maitre_ouvrage);
        if (res.email_maitre_ouvrage) setEmail(res.email_maitre_ouvrage);
        if (res.telephone_maitre_ouvrage) setTelephone(res.telephone_maitre_ouvrage);
        if (res.adresse_maitre_ouvrage) setAdresse(res.adresse_maitre_ouvrage);
        if (res.ville_maitre_ouvrage) setVille(res.ville_maitre_ouvrage);
        if (res.code_postal_maitre_ouvrage) setPostal(res.code_postal_maitre_ouvrage);
        if (res.adresse_projet) setAdresseProjet(res.adresse_projet);
        if (res.ville_projet) setVilleProjet(res.ville_projet);
        if (res.code_postal_projet) setPostalProjet(res.code_postal_projet);

        handleClickVariant("Informations extraites avec succès", "success");
      } else {
        handleClickVariant("Impossible d'extraire les informations", "error");
      }

      // Include the file as a devis annexe
      if (uploadRes?.url && uploadRes?.name) {
        onFileUploaded({ url: uploadRes.url, name: uploadRes.name });
      }
    } catch (e) {
      console.error(e);
      handleClickVariant("Erreur lors de l'extraction", "error");
    }
    onClose();
    setExtracting(false);
  };

  return (
    <Modal1 isOpen={true} onClose={onClose}>
      <div className="p-2 shadow-cyan-300 shadow-md bg-gradient-to-br rounded-4xl from-cyan-200 to-indigo-400">
        {extracting ? (
          <div className="bg-white flex flex-col w-fit rounded-3xl">
            <ExtractionLoading delay={10}></ExtractionLoading>
          </div>
        ) : (
          <div className="bg-white flex flex-col w-c500 rounded-3xl">
            <div className="flex flex-col w-full">
              <div className="border-b-1 p-4 text-h3">Extraction par IA</div>
              <div className="bg-neutral-50 p-4 flex flex-col">
                <div className="text-h3 text-shadow_50 mb-4">
                  Déposez un document (devis existant, fiche technique, permis
                  de construire...) pour que notre IA remplisse automatiquement
                  les informations du devis.
                </div>
                <div className="text-h3 text-black font-semibold mb-4">
                  Seules les 3 premières pages du fichier seront analysées. Le
                  fichier sera automatiquement ajouté aux annexes du devis.
                </div>
                <Dropzone3
                  onDrop={(files) => {
                    setSelectedDroppedFiles(files);
                    setDroppedFiles(files);
                  }}
                  onDelete={(file) =>
                    setDroppedFiles(droppedFiles.filter((f) => f.id !== file.id))
                  }
                  title="Glissez votre fichier ici"
                  loading={loadingDrop}
                  selected_files={selectedFiles}
                  setSelectedDroppedFiles={setSelectedDroppedFiles}
                  files={droppedFiles}
                ></Dropzone3>
              </div>
              <div className="flex flex-row gap-2 justify-between border-t-1 p-4">
                <SecondaryButton
                  className="items-center justify-center"
                  onClick={onClose}
                >
                  Continuer sans fichier
                </SecondaryButton>
                <PrimaryButton
                  className="min-w-fit"
                  onClick={() => handleExtractInfosFromFile(selectedFiles[0])}
                >
                  Récupérer les informations
                </PrimaryButton>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal1>
  );
}
